import { render, staticRenderFns } from "./testOpenai.vue?vue&type=template&id=686a8e6d&scoped=true"
import script from "./testOpenai.vue?vue&type=script&lang=js"
export * from "./testOpenai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686a8e6d",
  null
  
)

export default component.exports